
<div
  :class="'CModalContainer | UModalShadow | ' + anchorInfo.class"
  v-on:click="onCancel"
>
  <div
    class="CProseWithPadding m-pform-fix | UModalAppearance"
    v-on:click.stop
    :style="modalStyle"
  >
    <slot></slot>
  </div>
</div>
